import { ThemeToggle } from "../../../styles/facemeet-ui";

export const isValidEmail = (v) =>
  typeof v === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

export const parseError = (err) => {
  if (!err) return "Something went wrong";
  if (typeof err.detail === "string") return err.detail;
  if (Array.isArray(err.detail))
    return err.detail.map((e) => (typeof e === "string" ? e : e.msg || "Error")).join("; ");
  return "Something went wrong";
};

/** Brand block — used on every page. */
export function Brand({ tagline }) {
  return (
    <header className="fm-brand">
      <div className="fm-brand__mark" aria-hidden="true">
        {/* Camera glyph — heavier weight reads as a logo */}
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="6" width="14" height="12" rx="2.5" />
          <path d="m16 11 6-3v8l-6-3" />
        </svg>
      </div>
      <h1 className="fm-brand__title">FaceMeet</h1>
      {tagline && <p className="fm-brand__sub">{tagline}</p>}
    </header>
  );
}

/** Floating theme toggle — fixed top-right of every page. */
export function ThemeSlot() {
  return (
    <div className="fm-page__theme-slot">
      <ThemeToggle />
    </div>
  );
}

/** Reusable Ambient mesh background. */
export const Ambient = () => <div className="fm-ambient" aria-hidden="true" />;